'use es6';

import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

/**
 * Context for providing the card location, useful for `client.writeQuery` calls
 *
 * @param {object} value                     the context value
 * @param {Enum}   value.cardLocation        the card location, from cardLocationConstants (https://git.hubteam.com/HubSpot/customer-data-sidebar/blob/master/static/js/universal/cardLocationConstants.js)
 * @param {Enum}   value.parentCardLocation  the card location of the parent sidebar, or null if this is the root sidebar
 */

export const CardLocationContext = /*#__PURE__*/createContext({
  cardLocation: null,
  parentCardLocation: null
});
CardLocationContext.Provider.propTypes = {
  value: PropTypes.shape({
    cardLocation: PropTypes.string.isRequired,
    parentCardLocation: PropTypes.string
  }).isRequired
};
export const useCardLocationContext = () => useContext(CardLocationContext);